"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ButtonAppearance = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const ButtonAppearance = exports.ButtonAppearance = {
  BASE: "base",
  BRAND: "brand",
  DEFAULT: "",
  LINK: "link",
  NEGATIVE: "negative",
  POSITIVE: "positive"
};

/**
 * The type of the Button props.
 * @template P - The type of the props if providing a component to `element`
 */

/**
 * This is a [React](https://reactjs.org/) component for the Vanilla [Button](https://docs.vanillaframework.io/patterns/buttons/).
 *
 * Buttons are clickable elements used to perform an action, they can be used for buttons and link elements.
 * @template P - The type of the props if providing a component to `element`
 */
const Button = _ref => {
  let {
    appearance,
    children,
    className,
    dense,
    disabled,
    element: Component = "button",
    hasIcon,
    inline,
    onClick,
    small,
    ...buttonProps
  } = _ref;
  const classes = (0, _classnames.default)(appearance ? "p-button--".concat(appearance) : "p-button", {
    "has-icon": hasIcon,
    "is-dense": dense,
    "is-disabled": disabled,
    "is-inline": inline,
    "is-small": small
  }, className);
  const onClickDisabled = e => e.preventDefault();
  return /*#__PURE__*/_react.default.createElement(Component, _extends({
    className: classes,
    onClick: disabled ? onClickDisabled : onClick,
    "aria-disabled": disabled || undefined
  }, buttonProps), children);
};
var _default = exports.default = Button;